<template>
    <div>
        <div
            class="google-map"
            ref="googleMap"
        ></div>
        <template v-if="Boolean(this.google) && Boolean(this.map)">
            <slot
                :google="google"
                :map="map"
            />
        </template>
    </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
    props: {
        mapConfig: Object,
        apiKey: String
    },

    data() {
        return {
            google: null,
            map: null,
            markerClusterer: null
        };
    },

    async mounted() {
        const googleMapApi = await GoogleMapsApiLoader({
            apiKey: this.apiKey
        });
        this.google = googleMapApi;
        this.initializeMap();
    },

    methods: {
        initializeMap() {
            const mapContainer = this.$refs.googleMap;
            this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
        },
        clusterize(googleMarkers) {
            // console.log(`markerClusterer.MarkerClusterer:`, markerClusterer.MarkerClusterer)
            // console.log(`markerClusterer.MarkerClusterer googleMarkers:`, googleMarkers)

            if(this.markerClusterer) {
                this.markerClusterer.onRemove()
                return
            }

            const imagePath = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m";

            let map = this.map
            const markerClusterer = new MarkerClusterer(map, googleMarkers, {imagePath: imagePath});
            this.markerClusterer = markerClusterer
            var styles = markerClusterer.getStyles();
            let thiz = this
            markerClusterer.setCalculator(function(markers, numStyles) {
                // console.log("setCalculator(numMarkers" + markers.length + ", numStyles=" + numStyles + ")");
                // console.log("setCalculator markers:", markers);
                // return {
                //     text: "SOME TEXT: " + markers.length,
                //     index: 0
                // };

                // console.log(`test_calculatorFunc numStyles:${numStyles} markers:`, markers)
                var rate = {h: 0, g: 0, s: 0}
                for (let i = 0; i < markers.length; i++) {
                    // console.log(`marker:`, JSON.stringify(markers[i]))
                    let marker = markers[i]
                    rate.h += marker.marker.rate.h
                    rate.g += marker.marker.rate.g
                    rate.s += marker.marker.rate.s
                }
                var styleIndex = -1;
                // for (var i = 0; i < styles.length; i++) {
                //     if (styles[i].rate
                //         && styles[i].rate.h === rate.h
                //         && styles[i].rate.g === rate.g
                //         && styles[i].rate.s === rate.s) {
                //         styleIndex = i
                //     }
                // }
                if (styleIndex === -1) {
                    // let url = thiz.encodeSVG(thiz.getSVG())
                    // console.log(`url: ${url}`)
                    let imageSize = 60
                    styles.push({
                        width: imageSize,
                        height: imageSize,
                        rate: rate,
                        url: thiz.getSvgChartUrl(rate, imageSize),
                        // url: 'http://localhost:8080/admin/pieSVG?happy=1&soso=0&sad=55&size=60',
                        textColor: "#ff00ff",
                    })
                    styleIndex = styles.length - 1
                }
                // console.log(`styleIndex: ${styleIndex} length: ${this.styles.length} styles:`, this.styles)
                return {
                    text: "",
                    index: styleIndex
                };

            });
            // const markerCluster = new markerClusterer.MarkerClusterer({ map, googleMarkers });
        },
        getChartUrl(rate) {
            // return `http://localhost:8080/admin/cropImage?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}`
            return `https://devapi.air-vote.com/admin/pie2?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}&size=100`
            // return `http://localhost:8080/admin/cropImage?w=60&h=60&x=145&y=0&image_url=https%3A%2F%2Fimage-charts.com%2Fchart%3Fchco%3D228e00%2Cff9d00%2Cb51700%26chd%3Dt%3A${rate.h}%2C${rate.g}%2C${rate.s}%26chf%3Dbg%2Cs%2Cffffff00%26chof%3D.png%26chs%3D350x60%26cht%3Dp3%26chl%3D${rate.h}%7C${rate.g}%7C${rate.s}%26chlps%3Dfont.size%2C8%7Ccolor%2CFFFFFF`
        },
        getSvgChartUrl(rate, imageSize = 100) {
            // return `http://localhost:8080/admin/cropImage?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}`
            return `http://localhost:8080/admin/pieSVG?happy=${rate.h}&soso=${rate.g}&sad=${rate.s}&size=${imageSize}`
            // return `http://localhost:8080/admin/cropImage?w=60&h=60&x=145&y=0&image_url=https%3A%2F%2Fimage-charts.com%2Fchart%3Fchco%3D228e00%2Cff9d00%2Cb51700%26chd%3Dt%3A${rate.h}%2C${rate.g}%2C${rate.s}%26chf%3Dbg%2Cs%2Cffffff00%26chof%3D.png%26chs%3D350x60%26cht%3Dp3%26chl%3D${rate.h}%7C${rate.g}%7C${rate.s}%26chlps%3Dfont.size%2C8%7Ccolor%2CFFFFFF`
        },
        getSVG() {
            let happyP = 10;
            let okP = 20;
            let sadP = 70;
            let html = `<svg xmlns="http://www.w3.org/2000/svg" width="71" height="45" viewBox="0 0 71 45" fill="none">
  <rect width="71" height="37" rx="10" fill="#cb372b"/>
  <path d="M35 45L27 37H43L35 45Z" fill="#cb372b"/>
  <text x="50%" y="24"
        text-anchor="middle" fill="#FFF"
        font-size="14px" font-family="sans-serif" font-weight="bold">
        123
  </text>
</svg>`
            return html
        },
        getSVG2() {
            let happyP = 10;
            let okP = 20;
            let sadP = 70;
            let html = `<svg viewBox="0 0 64 64" class="pie">
                    <circle r="25%" cx="50%" cy="50%" style="stroke-dasharray: ${happyP} 100">
                    </circle>
                    <circle r="25%" cx="50%" cy="50%" style="stroke-dasharray: ${okP} 100; stroke: #fca341; stroke-dashoffset: -${happyP};">
                    </circle>
                    <circle r="25%" cx="50%" cy="50%" style="stroke-dasharray: ${sadP} 100; stroke: #c7322d; stroke-dashoffset: -${happyP + okP};">
                    </circle>
                </svg>`
            return html
        },
        encodeSVG(rawSvgString) {
            const symbols = /[\r\n%#()<>?\[\\\]^`{|}]/g;

            rawSvgString = rawSvgString
                .replace(/'/g, '"')
                .replace(/>\s+</g, '><')
                .replace(/\s{2,}/g, ' ');

            return (
                'data:image/svg+xml;utf-8,' +
                rawSvgString.replace(symbols, encodeURIComponent)
            );
        }
    }
};
</script>

<style scoped>
.google-map {
    width: 100%;
    min-height: 100%;
}
</style>
